import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "preview"]

  connect() {
    this.dirty = false
    this.boundBeforeUnload = this.beforeUnload.bind(this)
    window.addEventListener("beforeunload", this.boundBeforeUnload)

    // Listen for Turbo navigations
    this.boundTurboConfirm = this.turboConfirm.bind(this)
    document.addEventListener("turbo:before-visit", this.boundTurboConfirm)

    // Mark form as clean after submit
    this.element.addEventListener("submit", () => { this.dirty = false })

    // Track changes on all inputs within the form
    this.element.addEventListener("input", () => { this.dirty = true })
    this.element.addEventListener("change", () => { this.dirty = true })

    // Initial render of all previews
    this.textareaTargets.forEach((ta) => this.updatePreview(ta))
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.boundBeforeUnload)
    document.removeEventListener("turbo:before-visit", this.boundTurboConfirm)
  }

  beforeUnload(e) {
    if (this.dirty) {
      e.preventDefault()
      e.returnValue = ""
    }
  }

  turboConfirm(e) {
    if (this.dirty) {
      if (!confirm("You have unsaved changes. Are you sure you want to leave?")) {
        e.preventDefault()
      }
    }
  }

  render(e) {
    this.updatePreview(e.target)
  }

  updatePreview(textarea) {
    const previewId = textarea.dataset.previewTarget
    const preview = document.getElementById(previewId)
    if (!preview) return

    const iframe = preview.querySelector("iframe")
    if (!iframe) return

    const html = textarea.value || ""
    const doc = iframe.contentDocument || iframe.contentWindow.document
    doc.open()
    doc.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<style>
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
    color: #333;
    margin: 0;
    padding: 16px;
    font-size: 14px;
  }
  h1 { font-size: 22px; margin: 0 0 16px; color: #111; }
  h3 { font-size: 16px; margin: 16px 0 8px; color: #333; }
  p { margin: 8px 0; }
  a { color: #2563eb; }
  table { width: 100%; }
  img { max-width: 100%; }
</style>
</head>
<body>${html}</body>
</html>`)
    doc.close()

    // Auto-resize iframe to content height
    const resizeIframe = () => {
      try {
        const h = doc.documentElement.scrollHeight
        iframe.style.height = Math.max(h, 80) + "px"
      } catch(_) {}
    }
    iframe.onload = resizeIframe
    setTimeout(resizeIframe, 50)
  }
}
